PES = PES || {};
PES.ObfuscateEmail = function () {

    function reverseString(str) {
        return str.split("").reverse().join("");
    }
   
    function getEmailTargets() {
        let emailAnchors = $("a[data-email-target]").toArray();

        emailAnchors.forEach(email => {
            $(email).one("focus", function () {
                $(this).attr("href", `mailto:${reverseString(this.text)}`)
                    .css("direction", "ltr")
                    .text(reverseString(this.text));
            })
        })
    }

    var init = function () {
        getEmailTargets();
    };
    return {
        init: init
    }
}();